var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file 日期选择 年月选择
 * @author (zhanghao14)
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import moment from 'moment';

import { noop, classPrefix, contains } from '../../common/util';

/* global document */

var getTime = function getTime(direction, unit, prev) {
    if (!prev) {
        return;
    }
    var next = prev.clone();
    return next.add(direction, unit);
};

var CalendarHeader = function (_Component) {
    _inherits(CalendarHeader, _Component);

    function CalendarHeader() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CalendarHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CalendarHeader.__proto__ || Object.getPrototypeOf(CalendarHeader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            // month, year, decade, onlyYear, decadeByOnlyYear
            mask: null
        }, _this.bodyOnClick = function (e) {
            if (contains(_this.headerChooseWrap, e.target)) {
                return;
            }

            if (_this.props.monthPicker) {
                _this.setState({ mask: 'month' });
                return;
            }

            _this.setState({ mask: null });
        }, _this.onChange = function (value) {
            _this.props.onChange && _this.props.onChange(value);
        }, _this.goMonth = function (direction) {
            return getTime(direction, 'months', _this.props.value || moment());
        }, _this.goYear = function (direction) {
            return getTime(direction, 'years', _this.props.value || moment());
        }, _this.onPrevYearIconClicked = function () {
            _this.onChange(_this.goYear(-1));
        }, _this.onPrevMonthIconClicked = function () {
            _this.onChange(_this.goMonth(-1));
        }, _this.onNextYearIconClicked = function () {
            _this.onChange(_this.goYear(1));
        }, _this.onNextMonthIconClicked = function () {
            _this.onChange(_this.goMonth(1));
        }, _this.showMask = function () {
            if (!_this.state.mask) {
                return null;
            }

            var prefixCls = _this.props.prefixCls;

            return React.createElement(
                'div',
                { className: 'calendar-header-month-choose',
                    ref: function ref(el) {
                        _this.headerChooseWrap = el;
                    }
                },
                React.createElement(
                    'div',
                    { className: prefixCls + '-calendar-header' },
                    React.createElement(
                        'div',
                        null,
                        React.createElement('span', { className: prefixCls + '-calendar-header-prev-year',
                            onClick: _this.prevAndNextYearOnClick.bind(_this, -1, _this.state.mask)
                        }),
                        React.createElement(
                            'span',
                            { className: classPrefix + '-date-picker-calendar-header-current' },
                            React.createElement(
                                'span',
                                { className: classPrefix + '-date-picker-calendar-header-current-year',
                                    onClick: _this.showYearSelect
                                },
                                _this.renderHeaderText()
                            )
                        ),
                        React.createElement('span', { className: prefixCls + '-calendar-header-next-year',
                            onClick: _this.prevAndNextYearOnClick.bind(_this, 1, _this.state.mask)
                        })
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'calendar-header-month-choose-content' },
                    React.createElement(
                        'table',
                        null,
                        React.createElement(
                            'tbody',
                            null,
                            _this.renderItems()
                        )
                    )
                )
            );
        }, _this.showMonthSelect = function () {
            _this.setState({ mask: 'month' });
        }, _this.showYearSelect = function () {
            switch (_this.state.mask) {
                case 'onlyYear':
                    _this.setState({ mask: 'decadeByOnlyYear' });
                    break;
                case 'year':
                    _this.setState({ mask: 'decade' });
                    break;
                case 'month':
                case null:
                    _this.setState({ mask: 'year' });
                    break;
                case 'decade':
                case 'decadeByOnlyYear':
                    break;
            }
        }, _this.onlyShowYearSelect = function () {
            _this.setState({ mask: 'onlyYear' });
        }, _this.itemOnClick = function (index, disabled, position, lastAndNext) {

            if (disabled) {
                return;
            }

            var _this$props = _this.props,
                value = _this$props.value,
                onDateChange = _this$props.onDateChange,
                monthPicker = _this$props.monthPicker,
                onChange = _this$props.onChange;

            value = value || moment();
            switch (_this.state.mask) {
                case 'month':
                    if (monthPicker) {
                        onDateChange && onDateChange(value.clone().set('month', index - 1));
                        return;
                    }

                    onChange && onChange(value.clone().set('month', index - 1));
                    _this.setState({ mask: null });
                    break;
                case 'year':
                case 'onlyYear':
                    if (lastAndNext && position[0] === 0 && position[1] === 0) {
                        onChange && onChange(value.clone().add(-10, 'year'));
                        return;
                    } else if (lastAndNext && position[0] === 3 && position[1] === 2) {
                        onChange && onChange(value.clone().add(10, 'year'));
                        return;
                    } else {
                        onChange && onChange(value.clone().set('year', index));
                    }

                    if (_this.state.mask === 'year') {
                        _this.setState({ mask: 'month' });
                    } else {
                        _this.setState({ mask: null });
                    }
                    break;
                case 'decade':
                case 'decadeByOnlyYear':
                    if (lastAndNext && position[0] === 0 && position[1] === 0) {
                        onChange && onChange(value.clone().add(-100, 'year'));
                        return;
                    } else if (lastAndNext && position[0] === 3 && position[1] === 2) {
                        onChange && onChange(value.clone().add(100, 'year'));
                        return;
                    } else {
                        onChange && onChange(value.clone().set('year', index));
                    }

                    if (_this.state.mask === 'decade') {
                        _this.setState({ mask: 'year' });
                    } else {
                        _this.setState({ mask: 'onlyYear' });
                    }
                    break;
            }
        }, _this.prevAndNextYearOnClick = function (mark, stateType) {
            var number = void 0;
            var type = void 0;
            var _this$props2 = _this.props,
                value = _this$props2.value,
                onChange = _this$props2.onChange;

            value = value || moment();
            switch (stateType) {
                case 'month':
                    number = mark;
                    type = 'year';
                    break;
                case 'year':
                case 'onlyYear':
                    number = mark * 10; // 上下年代选择，10年一年代
                    type = 'year';
                    break;
                case 'decade':
                case 'decadeByOnlyYear':
                    number = mark * 100; // 上下世纪选择，100年一世纪
                    type = 'year';
                    break;
            }

            onChange && onChange(value.clone().add(number, type));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CalendarHeader, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.monthPicker) {
                this.setState({ mask: 'month' });
            }
            document.body.addEventListener('click', this.bodyOnClick);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.removeEventListener('click', this.bodyOnClick);
        }
    }, {
        key: 'renderItems',
        value: function renderItems() {
            var _this2 = this;

            var arr = [];
            switch (this.state.mask) {
                case 'month':
                    for (var i = 0; i < 4; i++) {
                        var temp = [];
                        for (var j = 0; j < 3; j++) {
                            temp[j] = i * 3 + j + 1; // 从1到12
                        }
                        arr.push(temp);
                    }
                    break;
                case 'year':
                case 'onlyYear':
                    for (var _i = 0; _i < 4; _i++) {
                        var _temp2 = [];
                        for (var _j = 0; _j < 3; _j++) {
                            // 从xxx9到xxx0
                            _temp2[_j] = this.startYearOrDecade() - 1 + _i * 3 + _j;
                        }
                        arr.push(_temp2);
                    }
                    break;
                case 'decade':
                case 'decadeByOnlyYear':
                    for (var _i2 = 0; _i2 < 4; _i2++) {
                        var _temp3 = [];
                        for (var _j2 = 0; _j2 < 3; _j2++) {
                            // 从xx99到xx00
                            _temp3[_j2] = this.startYearOrDecade('decade') - 10 + (_i2 * 3 + _j2) * 10;
                        }
                        arr.push(_temp3);
                    }
                    break;
            }

            var _props = this.props,
                value = _props.value,
                disableDate = _props.disableDate,
                monthPicker = _props.monthPicker;

            value = value || moment();
            var year = value.year();
            return arr.map(function (i, index1) {
                return React.createElement(
                    'tr',
                    { key: index1 },
                    i.map(function (j, index2) {
                        var disabled = monthPicker && disableDate(moment([year, j - 1]));
                        var lastAndNext = _this2.state.mask !== 'month' && (index1 === 0 && index2 === 0 || index1 === 3 && index2 === 2);
                        return React.createElement(
                            'td',
                            { key: j },
                            React.createElement(
                                'span',
                                {
                                    className: classnames({
                                        'selected-month': _this2.isSelectMonth(j),
                                        'disabled-month': disabled,
                                        'last-next': lastAndNext,
                                        'decade': _this2.state.mask === 'decade' || _this2.state.mask === 'decadeByOnlyYear'
                                    }),
                                    onClick: _this2.itemOnClick.bind(_this2, j, disabled, [index1, index2], lastAndNext)
                                },
                                _this2.renderText(j)
                            )
                        );
                    })
                );
            });
        }
    }, {
        key: 'renderText',
        value: function renderText(index) {
            switch (this.state.mask) {
                case 'month':
                    return index + '月';
                case 'year':
                case 'onlyYear':
                    return index;
                case 'decade':
                case 'decadeByOnlyYear':
                    return index + '~' + (index + 9);
            }
        }
    }, {
        key: 'isSelectMonth',
        value: function isSelectMonth(index) {

            var value = this.props.value || moment();
            var year = value.year();
            var month = value.month();
            switch (this.state.mask) {
                case 'month':
                    return month + 1 === index;
                case 'year':
                case 'onlyYear':
                    return year === index;
                case 'decade':
                case 'decadeByOnlyYear':
                    return year >= index && year <= index + 9;
            }
        }
    }, {
        key: 'startYearOrDecade',
        value: function startYearOrDecade() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'year';

            var deno = 10;
            if (type === 'decade') {
                deno = 100;
            }
            var value = this.props.value || moment();
            return parseInt(value.year() / deno, 10) * deno;
        }
    }, {
        key: 'renderHeaderText',
        value: function renderHeaderText() {
            var value = this.props.value || moment();
            var year = value.year();
            var startYear = this.startYearOrDecade();
            var startDecade = this.startYearOrDecade('decade');
            switch (this.state.mask) {
                case 'month':
                    return year + '年';
                case 'year':
                case 'onlyYear':
                    return startYear + '~' + (startYear + 9) + '\u5E74';
                case 'decade':
                case 'decadeByOnlyYear':
                    return startDecade + '~' + (startDecade + 99) + '\u5E74';
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames2, _classnames3, _classnames4, _classnames5;

            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                value = _props2.value,
                showYearAndMonthButton = _props2.showYearAndMonthButton,
                classPrefix = _props2.classPrefix;

            var containerClassName = classnames(_defineProperty({}, prefixCls + '-calendar-header', true));
            var containerProps = {
                className: containerClassName
            };
            var prevYearClassName = classnames((_classnames2 = {}, _defineProperty(_classnames2, prefixCls + '-calendar-header-prev-year', true), _defineProperty(_classnames2, prefixCls + '-isHide', !showYearAndMonthButton[0]), _classnames2));
            var prevYearProps = {
                className: prevYearClassName,
                onClick: this.onPrevYearIconClicked
            };
            var prevMonthClassName = classnames((_classnames3 = {}, _defineProperty(_classnames3, prefixCls + '-calendar-header-prev-month', true), _defineProperty(_classnames3, prefixCls + '-isHide', !showYearAndMonthButton[1]), _classnames3));
            var prevMonthProps = {
                className: prevMonthClassName,
                onClick: this.onPrevMonthIconClicked
            };
            var nextYearClassName = classnames((_classnames4 = {}, _defineProperty(_classnames4, prefixCls + '-calendar-header-next-year', true), _defineProperty(_classnames4, prefixCls + '-isHide', !showYearAndMonthButton[3]), _classnames4));
            var nextYearProps = {
                className: nextYearClassName,
                onClick: this.onNextYearIconClicked
            };
            var nextMonthClassName = classnames((_classnames5 = {}, _defineProperty(_classnames5, prefixCls + '-calendar-header-next-month', true), _defineProperty(_classnames5, prefixCls + '-isHide', !showYearAndMonthButton[2]), _classnames5));
            var nextMonthProps = {
                className: nextMonthClassName,
                onClick: this.onNextMonthIconClicked
            };
            var current = value || moment();
            var year = current.year();
            var month = current.month() + 1;
            return React.createElement(
                'div',
                containerProps,
                React.createElement(
                    'div',
                    null,
                    React.createElement('span', prevYearProps),
                    React.createElement('span', prevMonthProps),
                    React.createElement(
                        'span',
                        { className: classPrefix + '-date-picker-calendar-header-current' },
                        React.createElement(
                            'span',
                            { className: classPrefix + '-date-picker-calendar-header-current-year',
                                onClick: this.onlyShowYearSelect
                            },
                            year + '年'
                        ),
                        React.createElement(
                            'span',
                            { className: classPrefix + '-date-picker-calendar-header-current-month',
                                onClick: this.showMonthSelect
                            },
                            month + '月'
                        )
                    ),
                    React.createElement('span', nextYearProps),
                    React.createElement('span', nextMonthProps)
                ),
                this.showMask()
            );
        }
    }]);

    return CalendarHeader;
}(Component);

export default CalendarHeader;


CalendarHeader.defaultProps = {
    // base
    skin: '',
    className: '',
    style: {},
    // self
    value: null,
    prefixCls: classPrefix + '-date-picker',
    onChange: noop,
    showYearAndMonthButton: [true, true, true, true],
    classPrefix: classPrefix,
    disableDate: noop
};

CalendarHeader.propTypes = {
    skin: PropTypes.string,
    className: PropTypes.string,
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.object,
    onChange: PropTypes.func,
    showYearAndMonthButton: PropTypes.array,
    classPrefix: PropTypes.string,
    monthPicker: PropTypes.bool,
    onDateChange: PropTypes.func,
    disableDate: PropTypes.func
};